// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Informations_tabs__YsQEC"};